/** Explicit provenance keeps creator sharing separate from the paid JP library. */
export interface CreatorProgramAccessRecord {
  creation_source?: string | null;
  program_type?: string | null;
  program_scope?: string | null;
  is_published?: boolean | null;
  visibility?: string | null;
  deleted_at?: string | null;
  access_tier?: string | null;
}

export function isCreatorProgram(program: CreatorProgramAccessRecord | null | undefined): boolean {
  return program?.creation_source === 'frontend'
    && program.program_type === 'powerprompt'
    && program.program_scope === 'catalog';
}

export function isSharedCreatorProgram(program: CreatorProgramAccessRecord | null | undefined): boolean {
  return isCreatorProgram(program)
    && program?.is_published === true
    && (program.visibility === 'public' || program.visibility === 'unlisted')
    && !program.deleted_at;
}

export function isGuestAccessibleProgram(program: CreatorProgramAccessRecord | null | undefined): boolean {
  if (!program || program.is_published !== true || program.deleted_at
    || program.program_scope !== 'catalog') return false;

  if (isSharedCreatorProgram(program)) return true;
  // Official programs ignore visibility (cut 2026-10-13 program-visibility).
  return program.creation_source === 'admin'
    && (program.access_tier === 'free' || program.access_tier === null);
}
